// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TimelineEventExtendedProps  {
    _originalTypeClassName = "Loom.BO.TimelineEventExtendedProps";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TimelineEventExtendedProps.translate = translateService;
}
this.parts = [];
this.TimelineEventExtendedPropsKey = null;
this._key = this.TimelineEventExtendedPropsKey = 0; 
}

static translate: TranslateService;
_key: any;
parts:any;
private _TimelineEventExtendedPropsKey:any;
get TimelineEventExtendedPropsKey(): any {
    return this._TimelineEventExtendedPropsKey;
  }
set TimelineEventExtendedPropsKey(value: any) {
    this._TimelineEventExtendedPropsKey = value;
    this._key = value;
  }
static setparts = ($this, items) => {
                if (items == null) items = [];
                if ($this.parts == null) $this.parts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.parts.length > 0) {
                    Domain.TimelineEventExtendedProps.removeparts($this, $this.parts[0]);
                }

                Domain.TimelineEventExtendedProps.addManyparts($this, copyItems);
            }
static addManyparts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TimelineEventExtendedProps.addparts($this, items[i]);
                }
            }
static addparts = ($this, item) => {
                if ($this.parts == null) $this.parts = [];
                if (item == null || $this.parts.indexOf(item) > -1) return;
                $this.parts.push(item);
}
static addRangeparts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TimelineEventExtendedProps.addparts($this, item));
            }
static removeparts = ($this, item) => {
                if ($this == null || $this.parts == null || $this.parts.indexOf(item) === -1) return;
                var _index = $this.parts.indexOf(item);
                $this.parts.splice(_index, 1);
}
static clearparts = ($this) => { $this.parts = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TimelineEventExtendedPropsKey == null || $this.TimelineEventExtendedPropsKey == 0;
            }


}